import React, { useEffect } from "react";
import { useRouteError } from "react-router";
import * as Sentry from "@sentry/react";

export default function AppErrorBoundary() {
  const error = useRouteError();

  useEffect(() => {
    if (error) {
      Sentry.captureException(error);
    }
  }, [error]);

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        padding: "24px",
        fontFamily:
          "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        textAlign: "center",
        background: "#fafafa",
      }}
    >
      <h1 style={{ fontSize: "24px", marginBottom: "12px", color: "#333" }}>
        Something went wrong
      </h1>
      <p
        style={{
          fontSize: "16px",
          marginBottom: "24px",
          color: "#666",
          maxWidth: "480px",
          lineHeight: 1.5,
        }}
      >
        We ran into an unexpected problem. Please try reloading the page. If
        the issue keeps happening, contact support.
      </p>
      <button
        onClick={handleReload}
        style={{
          padding: "10px 24px",
          fontSize: "16px",
          background: "#1976d2",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        Reload
      </button>
    </div>
  );
}
